function getObjectDefaultRotation(uuid) {
    const worldQ = new THREE.Quaternion();
    const q = new THREE.Quaternion();

    while (uuid) {
        const objectData = Q3.data.assets.objects[uuid];
        const rot = objectData.rotation;

        const e = new THREE.Euler(rot.x, rot.y, rot.z, rot.order || THREE.Euler.DefaultOrder);
        q.setFromEuler(e);
        worldQ.premultiply(q);

        uuid = objectData.parent;
    }

    return worldQ;
}

export default getObjectDefaultRotation;
export { getObjectDefaultRotation };